// extracted by mini-css-extract-plugin
module.exports = {"caption":"ItemCaption_caption__1rQ-A"};